import { TabMenu } from '@/types/menu';

export function getCurrentTabMenu(pathname: string): TabMenu | undefined {
  // HOME かどうか
  const regex_home = /^\/home\/?$/;
  if (regex_home.test(pathname)) {
    return 'HOME';
  }

  // NOTE_CALENDAR かどうか
  const regex_note_calendar = /^\/notes\/calendar(?:\/\d{4}-\d{2})?(?:\/|$)/;
  if (regex_note_calendar.test(pathname)) {
    return 'NOTE_CALENDAR';
  }

  // NOTE かどうか
  const regex_note = /^\/notes\/?$/;
  if (regex_note.test(pathname)) {
    return 'NOTE';
  }

  // MYGOALS かどうか
  const regex_goals = /^\/goals\/?$/;
  if (regex_goals.test(pathname)) {
    return 'GOALS';
  }

  // SUPPORTERかどうか
  // const regex_supporter = /^\/supporters($|\/)/;
  const regex_supporter = /^\/supporters\/?$/;
  if (regex_supporter.test(pathname)) {
    return 'SUPPORTER';
  }

  // SUPPORTER_FEEDかどうか
  const regex_supporter_feed = /^\/supporters\/feeds?$/;
  if (regex_supporter_feed.test(pathname)) {
    return 'SUPPORTER_FEED';
  }

  return undefined;
}
